import styled from "styled-components/macro";

import background from "Payments/CreditCardAssets/CardBackgrounds/discover_texture.jpg";
import logo from "Payments/CreditCardAssets/LargeCardLogos/discover_logo.png";
import { motion } from "framer-motion";

import { Shine, iPhone, iPhoneMini } from "../styles";

export default function Discover({ isAlreadyExisting }) {
  return (
    <>
      <Background
        initial={isAlreadyExisting ? {} : { opacity: 0 }}
        animate={{ opacity: 1, transition: { delay: 0.2 } }}
        exit={{ opacity: 0 }}
      />
      <Shine />
      <Logo
        initial={isAlreadyExisting ? {} : { scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.8, opacity: 0, transition: { type: "tween" } }}
      />
      <CircleOutter
        initial={isAlreadyExisting ? {} : { x: 50 }}
        animate={{ x: 0, transition: { delay: 0.3 } }}
        exit={{ x: 50, opacity: 0, transition: { type: "tween" } }}
      >
        <CircleInner></CircleInner>
        <ItText>it</ItText>
      </CircleOutter>
    </>
  );
}

const Background = styled(motion.div)`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: url(${background});
  background-size: cover;
  background-position: center center;
`;

const Logo = styled(motion.div)`
  position: absolute;
  top: 40px;
  left: 0;
  right: 0;
  height: 32px;
  background-image: url(${logo});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
  @media screen and (max-width: ${iPhone.cssWidth}) {
    top: auto;
    bottom: ${iPhone.logoBottom};
    margin-bottom: -16px;
    height: 28px;
  }
  @media screen and (max-width: ${iPhoneMini.cssWidth}) {
    height: 24px;
    bottom: ${iPhoneMini.logoBottom};
    margin-bottom: -14px;
  }
`;

const CircleOutter = styled(motion.div)`
  height: 80px;
  position: absolute;
  width: 80px;
  border-radius: 80px;
  background-image: linear-gradient(
    to top right,
    rgba(255, 255, 255, 0.5),
    rgba(255, 255, 255, 0.1)
  );
  right: -40px;
  top: 14px;
  margin-bottom: -24px;
  display: flex;
  align-items: center;
  justify-content: center;
  @media screen and (max-width: ${iPhone.cssWidth}) {
    top: 10px;
  }
  @media screen and (max-width: ${iPhoneMini.cssWidth}) {
    top: 4px;
    width: 60px;
    height: 60px;
    right: -30px;
  }
`;

const CircleInner = styled.div`
  height: 70px;
  width: 70px;
  border-radius: 80px;
  background-image: url(${background});
  background-size: 400px;
  background-position: top right;
  filter: brightness(1.6);
  box-shadow: inset rgba(0, 0, 0, 1) 1px 2px 4px;
  @media screen and (max-width: ${iPhoneMini.cssWidth}) {
    width: 54px;
    height: 54px;
  }
`;
const ItText = styled.div`
  position: absolute;
  color: #fff;
  font-size: 36px;
  left: 12px;
  font-family: Arial;
  opacity: 0.9;
  @media screen and (max-width: ${iPhoneMini.cssWidth}) {
    font-size: 28px;
  }
`;
